module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', [_c('legend', [_c('i', {
    staticClass: "fa fa fa-list-ul"
  }), _vm._v(" \n      CHECKLIST\n      "), _c('div', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "bootstrap-label label-success",
    staticStyle: {
      "position": "relative",
      "top": "-4px",
      "margin-right": "10px"
    }
  }, [_vm._v("  " + _vm._s(_vm.totalChecked) + " Selecionados\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "bootstrap-label label-danger",
    staticStyle: {
      "position": "relative",
      "top": "-4px",
      "margin-right": "10px"
    }
  }, [_vm._v("  " + _vm._s(_vm.totalUnchecked) + " Selecionados\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "bootstrap-label label-primary",
    staticStyle: {
      "position": "relative",
      "top": "-4px"
    }
  }, [_vm._v(" " + _vm._s(_vm.totalItems) + " Total\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('section', [_c('label', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "input-lg",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "checklist-items-search",
      "placeholder": "Pesquisar..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.searchedChecklistItems), function(checklistItem) {
    return _c('section', [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', {
      staticClass: "toggle",
      class: {
        'toogle-active': _vm.selectedChecklistItems.includes(checklistItem.id)
      }
    }, [(_vm.selectedChecklistItems.includes(checklistItem.id)) ? _c('b', {
      staticClass: "fa fa-lg fa-check-square-o"
    }) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedChecklistItems),
        expression: "selectedChecklistItems"
      }],
      attrs: {
        "disabled": _vm.$parent.$refs.customFormPersonalData && _vm.$parent.$refs.customFormPersonalData.unidadesDiferentes,
        "type": "checkbox",
        "name": "name"
      },
      domProps: {
        "value": checklistItem.id,
        "checked": Array.isArray(_vm.selectedChecklistItems) ? _vm._i(_vm.selectedChecklistItems, checklistItem.id) > -1 : (_vm.selectedChecklistItems)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedChecklistItems,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = checklistItem.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedChecklistItems = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedChecklistItems = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedChecklistItems = $$c
          }
        }, _vm.clearAndFocusSearch]
      }
    }), _vm._v("\n            " + _vm._s(checklistItem.description) + "\n            "), _c('i', {
      attrs: {
        "data-swchon-text": "SIM",
        "data-swchoff-text": "NÃO"
      }
    })])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45f12f6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/VehicleEntry/Edit/ChecklistItemsForm.vue
// module id = 1003
// module chunks = 1